/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import * as React from 'react';
import { LayoutItem } from '@oneaudi/unified-web-components';
import { OpeningHours } from './OpeningHours';
import { AddressAndContact } from './AddressAndContact';
import type { VariantConfig } from './PartnerBusinessCard';
import { PartnerBusinessCardHeader } from './PartnerBusinessCardHeader';
import { PartnerContext } from '../PartnerProvider';

interface Props {
  variantConfig: VariantConfig;
}

export const PartnerBusinessCardFixedNarrow = ({
  variantConfig,
}: Props): React.ReactElement | false => {
  const { partner, hasOpeningHours } = React.useContext(PartnerContext);

  const { ctaBarButtonConfig = [] } = variantConfig;
  const { socialMedia = [] } = variantConfig;
  const {
    displayCtaBar,
    displayOfficialName,
    displayEmail,
    displayOpeningHours,
    displayPhone,
    isGoogleMapLink,
    isLinkedToPWS,
    showMoreInfoLink,
    showImage,
    showServiceList,
    showSocialMediaLinks,
  } = variantConfig?.contactDetails || variantConfig;
  const { headline = { headlineTag: 'h3', headlineOrder: '2' } } = variantConfig;

  return (
    partner &&
    partner.partnerId !== '' && (
      <>
        <PartnerBusinessCardHeader
          partner={partner}
          isNarrow
          displayOfficialName={displayOfficialName}
          showImage={showImage}
          showServiceList={showServiceList}
          isLinkedToPWS={isLinkedToPWS}
          headline={headline}
        />
        <LayoutItem margin={['var(--spacing-relative-lg)', 0, 0, 0]}>
          <AddressAndContact
            isNarrow
            isLinkedToPWS={isLinkedToPWS}
            displayEmail={displayEmail}
            displayPhone={displayPhone}
            isGoogleMapLink={isGoogleMapLink}
            showMoreInfoLink={showMoreInfoLink}
            displayCtaBar={displayCtaBar}
            ctaBarButtonConfig={ctaBarButtonConfig}
            showSocialMediaLinks={showSocialMediaLinks}
            socialMedia={socialMedia}
          />
        </LayoutItem>

        {displayOpeningHours && hasOpeningHours && (
          <LayoutItem margin={['var(--spacing-relative-lg)', 0, 0, 0]}>
            <OpeningHours data={partner} isNarrow />
          </LayoutItem>
        )}
      </>
    )
  );
};
